module.exports = __webpack_public_path__ + "img/03-28-160.ce84deef.jpg";